import React from 'react';
import { FaFolderOpen } from 'react-icons/fa';
import { AccessibleSelect } from '../../common';
import { RtModal, RtModalField, RtModalSection } from '../../ui/RtModal';

const PROJECT_TYPE_OPTIONS = [
  { value: 'WEB', label: 'Web' },
  { value: 'MOBILE', label: 'Mobile' },
  { value: 'DESKTOP', label: 'Desktop' },
  { value: 'API_BACKEND', label: 'ApiBackend' },
  { value: 'EMBEDDED', label: 'Embedded' },
  { value: 'CLOUD_DEVOPS', label: 'CloudDevOps' },
];

const PROJECT_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

const EditModal = ({
  setIsEditModalOpen,
  selectedProject,
  editName,
  setEditName,
  editDescription,
  setEditDescription,
  editProjectType,
  setEditProjectType,
  editProjectStatus,
  setEditProjectStatus,
  handleUpdateProject,
  isLoading,
}) => {
  const close = () => {
    if (!isLoading) setIsEditModalOpen(false);
  };

  const onSave = async () => {
    await handleUpdateProject(selectedProject?.id, {
      name: editName,
      description: editDescription,
      type: editProjectType,
      status: editProjectStatus,
    });
  };

  return (
    <RtModal
      open
      onClose={close}
      title="Edit Project"
      subtitle="Update your project details"
      size="md"
      closeDisabled={isLoading}
      closeOnBackdrop={!isLoading}
      footer={
        <>
          <button
            type="button"
            className="rt-btn rt-btn--secondary"
            onClick={close}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rt-btn rt-btn--primary"
            disabled={isLoading}
            onClick={onSave}
          >
            {isLoading ? 'Saving…' : 'Save changes'}
          </button>
        </>
      }
    >
      <div className="rt-modal-identity">
        <FaFolderOpen aria-hidden />
        <div>
          <span className="rt-modal-identity__eyebrow">Editing</span>
          <strong>{selectedProject?.name}</strong>
        </div>
      </div>

      <RtModalSection title="Basic information">
        <RtModalField label="Project name" htmlFor="edit-project-name">
          <input
            type="text"
            id="edit-project-name"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
            disabled={isLoading}
          />
        </RtModalField>
        <RtModalField label="Description" htmlFor="edit-project-description">
          <textarea
            id="edit-project-description"
            value={editDescription}
            onChange={(e) => setEditDescription(e.target.value)}
            rows={4}
            disabled={isLoading}
          />
        </RtModalField>
      </RtModalSection>

      <RtModalSection title="Settings">
        <div className="rt-modal__grid-2">
          <RtModalField label="Project type" htmlFor="edit-project-type">
            <AccessibleSelect
              id="edit-project-type"
              value={editProjectType}
              onChange={setEditProjectType}
              options={PROJECT_TYPE_OPTIONS}
              placeholder="Select Project Type"
              disabled={isLoading}
              aria-labelledby="edit-project-type-label"
            />
          </RtModalField>
          <RtModalField label="Project status" htmlFor="edit-project-status">
            <AccessibleSelect
              id="edit-project-status"
              value={editProjectStatus}
              onChange={setEditProjectStatus}
              options={PROJECT_STATUS_OPTIONS}
              placeholder="Select Project Status"
              disabled={isLoading}
              aria-labelledby="edit-project-status-label"
            />
          </RtModalField>
        </div>
      </RtModalSection>
    </RtModal>
  );
};

export default EditModal;
